// extracted by mini-css-extract-plugin
module.exports = {"body":"crawl_body__NZxtB","fade":"crawl_fade__XmiHA","starWars":"crawl_starWars__3pbrv","crawl":"crawl_crawl__drIm0","title":"crawl_title__bMSm3"};